export interface StorageProvider {
    key: 'gcs' | 'aws' | 'cloudflare';
    name: string;
    img: string;
    img_mini: string;
    imgWidth: number;
    imgHeight: number;
    modal: string;
}

export const allProviders: StorageProvider[] = [
    {
        key: 'gcs',
        name: 'Google Cloud',
        img: 'https://d1vyenbk43iobe.cloudfront.net/application/images/google_new.png',
        img_mini: 'https://d1vyenbk43iobe.cloudfront.net/application/images/google_mini.png',
        imgWidth: 156,
        imgHeight: 33,
        modal: 'showGcsModal',
    },
    {
        key: 'aws',
        name: 'Amazon S3',
        img: 'https://d1vyenbk43iobe.cloudfront.net/application/images/aws_new.png',
        img_mini: 'https://d1vyenbk43iobe.cloudfront.net/application/images/aws_mini.png',
        imgWidth: 54,
        imgHeight: 36,
        modal: 'showAwsModal',
    },
    {
        key: 'cloudflare',
        name: 'Cloudflare R2',
        img: 'https://d1vyenbk43iobe.cloudfront.net/application/images/cloudflare.png',
        img_mini: 'https://d1vyenbk43iobe.cloudfront.net/application/images/cloudflare_mini.png',
        imgWidth: 96,
        imgHeight: 36,
        modal: 'showCloudflareModal',
    },
];
